module.exports = __webpack_public_path__ + "img/DKFT11195.88dffe3b.png";